angular
  .module("myApp")
  .controller("PublicFilesController", ($scope, uuiData) => {
    $scope.exception = void 0
    $scope.dto = uuiData.list("publiskie_faili", void 0, void 0, (e) => {
      $scope.exception = e.data
    })
  })
  .controller(
    "PublicFilesManagerController",
    function ($scope, $q, Notification, Dialog, Upload, PublicFileUpload) {
      $scope.view = "publiskie_faili_mgr_list"
      this.reload = () => $scope.$broadcast("reload")

      this.saveUploaded = (dto) => {
        const f = new PublicFileUpload({
          id: dto.id,
          file_info_id: dto.file_info_id,
          nosaukums: dto.nosaukums,
          apraksts: dto.apraksts,
          ir_aktivs: dto.ir_aktivs,
          ir_saistoss_ekspertam: dto.ir_saistoss_ekspertam,
        })

        return f.$save().then(
          () => {
            this.reload()
            return true
          },
          (e) => {
            Notification.error(e.data)
            return $q.reject(e.data)
          }
        )
      }

      this.openFile = (f) => {
        if (f === void 0) {
          f = {
            new: true,
            ir_aktivs: true,
          }
        }

        return Dialog.dialog("pages/files/file.form.html", f, {}, (p, action) => {
          if (action !== "save") {
            return
          }

          if (!p.file) {
            return this.saveUploaded(p)
          }

          return Upload.upload({
            url: "./upload",
            method: "POST",
            file: p.file,
          })
            .progress((evt) => {
              p.progress = {
                loaded: evt.loaded,
                total: evt.total,
                percentage: $scope.percentize(evt.loaded, evt.total),
              }
            })
            .then((response) => {
              p.file_info_id = response.data.id
              return this.saveUploaded(p)
            })
            .catch((e) => {
              p.loading = false

              const data = e.data || e

              if (typeof data === "string" && data.includes("EntityStreamSizeException")) {
                return $q.reject("Ielādējamais fails ir par lielu.")
              }

              return $q.reject(data)
            })
        })
      }
      $scope.gridOptions = {
        filtersUrl: "pages/filter-text.html",
        defaultFilters: {},
        initialFilters: {},
        noDataLabel: "Nav atrasts neviens fails.",
        rowClick: this.openFile,
        buttons: [
          {
            label: "Ielādēt jaunu failu",
            class: "btn-success",
            icon: "fa-plus",
            click: this.openFile,
          },
        ],
      }
    }
  )
